// Import components
import React, { useEffect, useMemo, useState } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import { Modal, Label, ModalHeader, Card, CardBody, Row, Col, Alert, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import Comingsoon from "../../../assets/images/comesoon.png"
import axios from "axios";
import OrderCancellationModal from '../../../Components/custom/OrderCancellationModal';
import OrderTransactionHistoryExpander from '../../../Components/custom/OrderTransactionHistoryExpander';

const Cst_Orders = () => {

    const [showloader, setshowloader] = useState(true);
    const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: "Messages here.", time: "2500" });

    const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false });
    };

    const [orders, setOrders] = useState<[] | null>(null);
    const [paidOrders, setPaidOrders] = useState<[] | null>(null);
    const [pendingOrders, setPendingOrders] = useState<[] | null>(null);
    const [cancelledOrders, setCancelledOrders] = useState<[] | null>(null);
    const [selectedStatus, setSelectedStatus] = useState<string>("paid");
    const [cancellationModal, setCancellationModal] = useState<{ open: boolean; order: any | null }>({
        open: false,
        order: null,
    });

    const fetchOrders = async (status: string = "paid") => {
        try {
            setshowloader(true);
            const response = await axios.post(
                `/payments/customer/orders/`,
                {
                    status: status,
                },
                { withCredentials: true }
            );
            if (response && response.status === "SENT") {
                if (status === "paid") {
                    setPaidOrders(response.orders);
                } else if (status === "pending") {
                    setPendingOrders(response.orders);
                } else if (status === "cancelled") {
                    setCancelledOrders(response.orders);
                }
                setOrders(response.orders);
            }
            setshowloader(false);
        } catch (error: any) {
            console.error("Error fetching orders:", error);
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    }

    useEffect(() => {   
        fetchOrders("paid");
    }, []);

    const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const status = e.target.value;
        setSelectedStatus(status);
        let ordersData: any[] | null = null;
        if (status === "paid") ordersData = paidOrders;
        else if (status === "pending") ordersData = pendingOrders;
        else if (status === "cancelled") ordersData = cancelledOrders;
        if (ordersData === null) {
            fetchOrders(status);
        } else {
            setOrders(ordersData as []);
        }
    };

    const handleOpenCancellation = (order: any) => {
        setCancellationModal({ open: true, order });
    };

    const handleCloseCancellation = () => {
        setCancellationModal({ open: false, order: null });
    };

    const handleCancellationSuccess = () => {
        // Refresh orders after successful cancellation
        fetchOrders(selectedStatus);
        // Success message is already shown in the modal, so we can either skip this or show a brief confirmation
    };


    document.title = "Orders | BizServe";

    return (
        <div className="page-content">
            {alertMsgg.open && (
                <Alert
                    color={alertMsgg.type === "success" ? "success" : "danger"}
                    toggle={handleAlertMsggClose}
                    fade={false}
                    style={{ fontWeight: "bold" }}
                >
                    {alertMsgg.content}
                </Alert>
            )}
            <div className="loaderContainer" hidden={!showloader}>
                <div className="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="container-fluid px-0 px-md-3 py-3" style={{ minHeight: '90vh' }}>
                <Breadcrumbs title="" breadcrumbItem="Orders" />
                <div className="row g-4" style={{ maxWidth: 1300, margin: '0 auto' }}>
                    {/* Filters Card */}
                    <div className="col-12 col-md-4 col-lg-3">
                        <Card className="rounded-4 border-0 shadow-sm bg-white h-100">
                            <CardBody className="p-4">
                                <div className="mb-3 fw-bold fs-5 text-primary-emphasis">Filters</div>
                                <div className="mb-2">
                                    <label htmlFor="orderStatus" className="form-label fw-semibold">Order Status</label>
                                    <select id="orderStatus" className="form-select" value={selectedStatus} onChange={handleStatusChange}>
                                        <option value="paid">Paid</option>
                                        <option value="pending">Pending</option>
                                        <option value="cancelled">Cancelled</option>
                                    </select>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                    {/* Orders Card */}
                    <div className="col-12 col-md-8 col-lg-9">
                        <Card className="rounded-4 border-0 shadow-lg bg-white" style={{ minHeight: 600 }}>
                            <CardBody className="p-4">
                                {orders && orders.length === 0 && !showloader ? (
                                    <div className="text-center py-5">
                                        {/* <img src={Comingsoon} alt="No Orders" style={{ maxWidth: 200, opacity: 0.6 }} /> */}
                                        <div className="mt-3 text-muted fs-5">No orders found.</div>
                                    </div>
                                ) : (
                                    orders && orders.map((order: any, idx: number) => {
                                        const isCompanyFormation = order.order_type === 'company_formation';
                                        return (
                                        <div key={order.order_id || idx} className="mb-5 p-4 rounded-4 shadow-sm bg-gradient order-card" style={{ background: 'linear-gradient(120deg, #e0e7ff 60%, #f1f5f9 100%)', border: '1px solid #dbeafe' }}>
                                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
                                                <div className="d-flex align-items-end">
                                                    <span className="fw-bold me-2 text-primary-emphasis" style={{ fontSize: 14 }}>Order ID:</span>
                                                    <span className="text-primary fw-semibold" style={{ fontSize: 12 }}>#{order.order_uuid}</span>
                                                    {isCompanyFormation && (
                                                        <span className="badge bg-info text-white ms-2" style={{ fontSize: 10 }}>
                                                            <i className="bx bx-building me-1"></i>
                                                            Company Formation
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    {!isCompanyFormation && (
                                                        <span className={`badge px-3 py-1 fs-8 ${getStatusColor(order.payment_status)}`}>{formatOrderStatus(order.payment_status)}</span>
                                                    )}
                                                    <span className="text-muted small ms-2">Placed: {formatDate(order.created_at)}</span>
                                                </div>
                                                <div className="d-flex align-items-center gap-3">
                                                    <div className="fw-bold text-success-emphasis fs-5">Total: ${order.total_price?.toFixed(2) ?? '0.00'}</div>
                                                    {order.payment_status === 'paid' && !isCompanyFormation && (() => {
                                                        // Check if any product can be cancelled
                                                        const planPurchase = order.purchases?.find((p: any) => p.product_type === 'plan');
                                                        const hasCancellableProducts = order.purchases?.some((purchase: any) => {
                                                            const remainingQty = purchase.remaining_quantity ?? purchase.quantity;
                                                            if (remainingQty <= 0) return false;
                                                            
                                                            // Check cancellation period
                                                            if (purchase.product_type === 'onetimeproduct') {
                                                                if (!purchase.curr_prd_strt || !purchase.cancellation_days) return true;
                                                                const purchaseDate = new Date(purchase.curr_prd_strt);
                                                                const now = new Date();
                                                                const daysSincePurchase = Math.floor((now.getTime() - purchaseDate.getTime()) / (1000 * 60 * 60 * 24));
                                                                return daysSincePurchase <= (purchase.cancellation_days || 5);
                                                            } else if (['plan', 'addon', 'subscriptionaddon', 'planoptionals'].includes(purchase.product_type)) {
                                                                if (planPurchase) {
                                                                    if (!planPurchase.curr_prd_strt || !planPurchase.cancellation_days) return true;
                                                                    const purchaseDate = new Date(planPurchase.curr_prd_strt);
                                                                    const now = new Date();
                                                                    const daysSincePurchase = Math.floor((now.getTime() - purchaseDate.getTime()) / (1000 * 60 * 60 * 24));
                                                                    return daysSincePurchase <= (planPurchase.cancellation_days || 5);
                                                                }
                                                                return true; // Default allow if no plan found
                                                            }
                                                            return true;
                                                        });
                                                        
                                                        if (!hasCancellableProducts) return null;
                                                        
                                                        return (
                                                            <UncontrolledDropdown>
                                                                <DropdownToggle tag="button" className="btn btn-sm btn-light" caret>
                                                                    <i className="bx bx-dots-vertical-rounded"></i>
                                                                </DropdownToggle>
                                                                <DropdownMenu end>
                                                                    <DropdownItem onClick={() => handleOpenCancellation(order)}>
                                                                        <i className="bx bx-x-circle text-danger me-2"></i>
                                                                        Cancel / Refund
                                                                    </DropdownItem>
                                                                </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                            <div className="ps-1">
                                                {order.purchases && order.purchases.length > 0 ? (
                                                    <div className="table-responsive">
                                                        <table className="table align-middle mb-0" style={{ fontSize: 15 }}>
                                                            <thead className="">
                                                                <tr>
                                                                    <th>Product</th>
                                                                    <th>Description</th>
                                                                    <th>Type</th>
                                                                    <th>Partner</th>
                                                                    <th>Qty</th>
                                                                    <th>End</th>
                                                                    <th>Price</th>
                                                                    {/* <th>Active</th> */}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {order.purchases.map((purchase: any, pidx: number) => (
                                                                    <React.Fragment key={purchase.purchase_id || purchase.id || pidx}>
                                                                    <tr>
                                                                        <td className={purchase.product_type === 'plan' || purchase.product_type === 'companyformation' ? 'text-dark' : 'text-dark'}>
                                                                            {purchase.product_title}
                                                                            {purchase.domain && (
                                                                                <div className="text-secondary" style={{ fontSize: 11, fontWeight: 400, textTransform: 'capitalize' }}>
                                                                                    {purchase.domain === 'Company Formation' ? '' : purchase.domain}
                                                                                </div>
                                                                            )}
                                                                            {(() => {
                                                                                // Check if product is a subscription based on validity field
                                                                                const validity = purchase.validity;
                                                                                const isSubscriptionProduct = validity && validity !== '' && validity !== 'lifetime' && validity !== 'custom' && ['plan', 'addon', 'subscriptionaddon', 'planoptionals'].includes(purchase.product_type);
                                                                                const isOneTimeProduct = purchase.product_type === 'onetimeproduct';
                                                                                const isActive = purchase.curr_prd_end ? new Date(purchase.curr_prd_end) >= new Date() : purchase.pack_active;
                                                                                
                                                                                // Show cancellation/refund status
                                                                                if (purchase.cancellation_status) {
                                                                                    if (isOneTimeProduct) {
                                                                                        // For one-time products: show refund status
                                                                                        if (purchase.cancellation_status === 'completed') {
                                                                                            return (
                                                                                                <div className="mt-1">
                                                                                                    <span className="badge bg-warning text-white" style={{ fontSize: 10 }}>
                                                                                                        <i className="bx bx-dollar-circle me-1"></i>
                                                                                                        Refunded
                                                                                                    </span>
                                                                                                </div>
                                                                                            );
                                                                                        } else if (purchase.cancellation_status === 'requested' || purchase.cancellation_status === 'processing') {
                                                                                            return (
                                                                                                <div className="mt-1">
                                                                                                    <span className="badge bg-warning text-dark" style={{ fontSize: 10 }}>
                                                                                                        <i className="bx bx-time me-1"></i>
                                                                                                        Refund Requested
                                                                                                    </span>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    } else if (isSubscriptionProduct) {
                                                                                        // For subscription products: show subscription cancelled
                                                                                        return (
                                                                                            <div className="mt-1">
                                                                                                <span className="badge bg-warning text-dark" style={{ fontSize: 10 }}>
                                                                                                    <i className="bx bx-info-circle me-1"></i>
                                                                                                    Subscription Cancelled
                                                                                                </span>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                } else if (isSubscriptionProduct && isActive) {
                                                                                    // Active subscription
                                                                                    return (
                                                                                        <div className="mt-1">
                                                                                            <span className="badge bg-success text-white" style={{ fontSize: 10 }}>
                                                                                                <i className="bx bx-check-circle me-1"></i>
                                                                                                Subscription Active
                                                                                            </span>
                                                                                        </div>
                                                                                    );
                                                                                }
                                                                                return null;
                                                                            })()}
                                                                        </td>
                                                                        <td className="text-muted small" style={{ position: 'relative' }}>
                                                                            {purchase.description && purchase.description.length > 50 ? (
                                                                                <>
                                                                                    <span>{purchase.description.substring(0, 50)}</span>
                                                                                    <span
                                                                                        style={{ color: '#1976d2', cursor: 'pointer' }}
                                                                                        onMouseEnter={e => {
                                                                                            const tip = document.getElementById(`purchase-desc-tip-${order.order_id || order.order_uuid}-${pidx}`);
                                                                                            if (tip) tip.style.display = 'block';
                                                                                        }}
                                                                                        onMouseLeave={e => {
                                                                                            const tip = document.getElementById(`purchase-desc-tip-${order.order_id || order.order_uuid}-${pidx}`);
                                                                                            if (tip) tip.style.display = 'none';
                                                                                        }}
                                                                                    >
                                                                                        {' '}...more
                                                                                    </span>
                                                                                    <div
                                                                                        id={`purchase-desc-tip-${order.order_id || order.order_uuid}-${pidx}`}
                                                                                        style={{
                                                                                            display: 'none',
                                                                                            position: 'absolute',
                                                                                            top: '100%',
                                                                                            left: '50%',
                                                                                            transform: 'translateX(-50%)',
                                                                                            marginTop: 8,
                                                                                            background: '#222',
                                                                                            color: '#fff',
                                                                                            padding: 10,
                                                                                            borderRadius: 8,
                                                                                            fontSize: 12,
                                                                                            zIndex: 10,
                                                                                            minWidth: 200,
                                                                                            maxWidth: 300,
                                                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                                            whiteSpace: 'normal',
                                                                                            wordBreak: 'break-word',
                                                                                        }}
                                                                                    >
                                                                                        {purchase.description}
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                purchase.description || '-'
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {purchase.product_type && (
                                                                                <span className="badge bg-info text-light">
                                                                                    {PRODUCT_TYPE_LABELS[purchase.product_type] || (purchase.product_type === 'companyformation' ? 'Company Formation' : purchase.product_type)}
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {purchase.partner ? (
                                                                                <div>
                                                                                    <span className="badge bg-primary text-white">
                                                                                        {purchase.partner.partner_name || 'N/A'}
                                                                                    </span>
                                                                                    {purchase.partner.partner_email && (
                                                                                        <div className="text-muted small" style={{ fontSize: 11 }}>
                                                                                            {purchase.partner.partner_email}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                <span className="text-muted small">-</span>
                                                                            )}
                                                                        </td>
                                                                        <td><span className="badge bg-secondary">{purchase.quantity || 1}</span></td>
                                                                        <td>
                                                                            {purchase.curr_prd_end ? (
                                                                                <span className="badge bg-light text-dark">{formatDate(purchase.curr_prd_end)}</span>
                                                                            ) : '-'}
                                                                        </td>
                                                                        <td className="fw-bold text-primary">
                                                                            {purchase.total_price && purchase.total_price > 0 
                                                                                ? `$${purchase.total_price.toFixed(2)}` 
                                                                                : <span className="text-muted small">Included in Total</span>
                                                                            }
                                                                        </td>
                                                                        {/* <td>
                                                                            {(() => {
                                                                                // Check if service is still active based on end date
                                                                                if (purchase.curr_prd_end) {
                                                                                    const endDate = new Date(purchase.curr_prd_end);
                                                                                    const isActive = endDate >= new Date();
                                                                                    return (
                                                                                        <i className={`bi ${isActive ? 'bx bxs-check-circle text-success' : 'bx bxs-x-circle text-danger'}`} style={{ fontSize: 18 }}></i>
                                                                                    );
                                                                                }
                                                                                // If no end date, check pack_active as fallback
                                                                                return (
                                                                                    <i className={`bi ${purchase.pack_active ? 'bx bxs-check-circle text-success' : 'bx bxs-x-circle text-danger'}`} style={{ fontSize: 18 }}></i>
                                                                                );
                                                                            })()}
                                                                        </td> */}
                                                                    </tr>

                                                                    </React.Fragment>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div className="text-muted small">No purchases in this order.</div>
                                                )}
                                            </div>

                                            {/* Order-Level Transaction History Expander - Only for subscription orders */}
                                            {!isCompanyFormation && order.purchases && order.purchases.some((p: any) => p.stripe_subscription_id) && (
                                                <OrderTransactionHistoryExpander
                                                    orderId={order.order_id}
                                                    totalAmount={order.total_price}
                                                    productCount={order.purchases.filter((p: any) => p.stripe_subscription_id).length}
                                                />
                                            )}
                                            
                                        </div>
                                    )})
                                )}
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>

            {/* Cancellation Modal */}
            <OrderCancellationModal
                isOpen={cancellationModal.open}
                toggle={handleCloseCancellation}
                order={cancellationModal.order}
                isAdmin={false}
                onSuccess={handleCancellationSuccess}
            />
        </div>
    );
};

export default Cst_Orders;

// Helper functions for formatting
function formatDate(dateStr: string) {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
function formatOrderStatus(status: string) {
    switch (status) {
        case 'paid': return 'Paid';
        case 'pending': return 'Pending';
        case 'cancelled': return 'Cancelled';
        default: return status;
    }
}

// Add getStatusColor helper for colorful status badges
function getStatusColor(status: string) {
    switch (status) {
        case 'paid': return 'bg-success bg-gradient text-white';
        case 'pending': return 'bg-warning bg-gradient text-dark';
        case 'cancelled': return 'bg-danger bg-gradient text-white';
        default: return 'bg-secondary';
    }
}

// Map for product_type display names
const PRODUCT_TYPE_LABELS: Record<string, string> = {
    plan: 'Plan/Package',
    planoptionals: 'Optional',
    addon: 'Add-On',
    subscriptionaddon: 'Subscription',
    onetimeproduct: 'Product/Service',
    companyformation: 'Company Formation',
};
